import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/map.svg'


const _hoisted_1 = { class: "revenue-by-branches-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "p-0 mb-0 list-unstyled" }
const _hoisted_5 = { class: "flag d-flex align-items-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "d-block fw-medium" }
const _hoisted_8 = { class: "percentage-progress d-flex align-items-center" }
const _hoisted_9 = ["aria-valuenow"]
const _hoisted_10 = { class: "d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mb-lg-20\" data-v-fc06358a><h5 class=\"mb-0\" data-v-fc06358a>Low Stock Alerts</h5><div class=\"dropdown action-opt\" data-v-fc06358a><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-fc06358a><i class=\"ri-more-2-fill\" data-v-fc06358a></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-fc06358a><li data-v-fc06358a><button class=\"dropdown-item\" data-v-fc06358a>This Day</button></li><li data-v-fc06358a><button class=\"dropdown-item\" data-v-fc06358a>This Week</button></li><li data-v-fc06358a><button class=\"dropdown-item\" data-v-fc06358a>This Month</button></li><li data-v-fc06358a><button class=\"dropdown-item\" data-v-fc06358a>This Year</button></li></ul></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "map"
          })
        ], -1)),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "d-flex align-items-center justify-content-between"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.flag,
                  alt: item.country
                }, null, 8, _hoisted_6),
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.country), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "progress trezo-progress w-100",
                  role: "progressbar",
                  "aria-valuenow": item.percentage,
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["progress-bar", _ctx.getProgressBarClass(item.percentage)]),
                    style: _normalizeStyle({ width: item.percentage + '%' })
                  }, null, 6)
                ], 8, _hoisted_9),
                _createElementVNode("span", _hoisted_10, _toDisplayString(item.percentage) + "%", 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}